<div class="iframe-container">
  <iframe [src]="url" (load)="onIframeLoaded($event)" allowfullscreen *ngIf="url"></iframe>
</div>
<app-fullscreen-spinner *ngIf="!isReady"></app-fullscreen-spinner>